import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class MastersKeyStringValue {

    static ACTION_DELETE = 'delete';
    static ACTION_UPDATE = 'update';
    static ACTION_NEW = 'new';

    static ACTION_MessageDialog = 'messageDialog';
    static ACTION_MessageDialogReload = 'messageDialogReload';
    static ACTION_YNDialog = 'ynDialog';
    static ACTION_YNDialogTF = 'ACTION_YNDialogTF';

    static ACTION_MessageDialogSucceed = 'messageDialogsucceed';
    static ACTION_BillpayConfirmPackage = 'confirmPackage';


    static STATUS_SUCCESS = 'success';
    static STATUS_FAIL = 'fail';

    static TABLE_Bed = 'tBed';
    static TABLE_Shop = 'tShop';
    static TABLE_ShopBldg = 'tShopBldg';
    static TABLE_PatientType = 'tPatientType';
    static TABLE_Employee = 'temployee';

    static TABLE_Medicine = 'tMedicine';

    static TABLE_Vendor = 'tVendor';

    static TABLE_BookAux = 'tBookAux';

    static TABLE_ChangeAcct = 'tChangeAcct';

    static TABLE_Patient = 'tPatient';

    static TABLE_ItemCate = 'tItemCate';
    static TABLE_Item = 'tItem';

    static TABLE_BOOKING = 'tBooking';
    static TABLE_Package = 'tPackage';

    static TABLE_PriceBook = 'tPriceBook';

    static TABLE_Payment = 'tPayment';

    static TABLE_ConsultHead = 'tConsultHead';
    static TABLE_ConsultDetail = 'tConsultDetail';

    static TABLE_GRN = 'tGRN';
    static TABLE_Stock = 'Stock';

    static TABLE_Inbound = 'Inbound';
    static TABLE_Outbound = 'Outbound';

    static TABLE_Permission = 'Permission';


    static TABLE_VoidVoucher_VoidPayment = 'VoidVoucher_VoidPayment';
    static TABLE_VoidVoucher_VoidBill = 'VoidVoucher_VoidBill';

    static TABLE_Currency = 'tCurrency';
    static TABLE_GLSetting = 'glSetting';
    static TABLE_Journal = 'Journal';



}


